









import Vue, { PropType } from 'vue';

interface Text {
  text: string;
  to?: string | Location;
}

export default Vue.extend({
  name: 'GMainHeading',
  props: {
    texts: Array as PropType<Text[]>,
    default: [],
  },
});
